// let reg_textValue = /{([a-zA-Z0-9_\$]+)}/g
export default {
  install(Vue) {
    Vue.filter("express", (v, express) => {
      if (v) {
        if (dsf.type(v) == "object") {
          return evalValue(v, express);
          // let str = textOrValue.replace(reg_textValue, (s, s1, s2, s3, s4) => {
          //   return v?.[s1] || "";
          // });
          // return str;
          // return v['attach'] ? `${v[textOrValue]} (${v['attach']})` : v[textOrValue];
        } else if (dsf.type(v) == "array") {
          return _.map(v, function (it) {
            return evalValue(it, express);
          }).join("，");
        }
        return v;
      } else {
        return "";
      }
    });
  }
};

function evalValue(obj, express) {
  return dsf.isEqualObject(obj) ? '' : dsf.express.eval(express, obj);
}